import { IoClose, IoSearch } from "react-icons/io5";
import { Card, Container } from "../../styles";
import { useEffect, useState } from "react";
import { LuUsers } from "react-icons/lu";
import { useUsers } from "../../../../../hooks/users";
import { useAuth } from "../../../../../hooks/auth";

export default function List({
  status,
  setStatus,
  handleClose,
  setSelectedUser,
}) {
  const { users } = useUsers();
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    console.log("users", users);
  }, []);

  const selectUser = (user) => {
    setStatus("edit_user");
    setSelectedUser(user);
  };

  const filteredUsers = users.filter((item) => {
    // Ignora usuários com cargo "god"
    if (item.cargo === "god") return false;
    // Se não houver termo de busca, exibe todos
    if (searchTerm.trim() === "") return true;
    // Caso contrário, filtra por nome ou email (ignorando maiúsculas/minúsculas)
    return (
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <Card>
      <div className="header">
        <div className="btn" onClick={handleClose}>
          <IoClose />
        </div>
        <LuUsers />
        <p>Usuários</p>
      </div>
      <div className="search">
        <IoSearch />
        <input
          placeholder="Procurar usuário"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="display">
        {filteredUsers.map((userItem) => (
          <div
            key={userItem._id}
            className="item"
            onClick={() => selectUser(userItem)}
          >
            <div className="thumb">
              <div
                className="circle"
                style={{ backgroundColor: userItem.color }}
              >
                <p>{userItem.name.charAt(0).toUpperCase()}</p>
              </div>
            </div>
            <div className="content">
              <p>{userItem.name}</p>
              <p>{userItem.email}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bottom">
        {["god", "admin"].includes(user.cargo) && (
          <div className="btn" onClick={() => setStatus("new_user")}>
            <p>ADICIONAR</p>
          </div>
        )}
      </div>
    </Card>
  );
}
